import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ScheduledDiscovery, TimeUnit, DiscoverySettings, DiscoveryMethod } from 'DiscoveryEngine.TS/Discovery';
import { IpScope } from 'DiscoveryEngine.TS/Core';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';

@Component({
    selector: 'sched-disc-config-basic',
	templateUrl: './sched-disc-config-basic.component.html',
	styleUrls: ['./sched-disc-config-basic.component.scss']
})
export class SchedDiscConfigBasicComponent extends SchedDiscConfigComponentBase {

	public Name: UntypedFormControl;
	public Method: UntypedFormControl;
	public RefreshMode: UntypedFormControl;
	public ReportSubtaskStatus: UntypedFormControl;
	public KeepStalePortReport: UntypedFormControl;
	public DisableStalePorts: UntypedFormControl;
	public DisableStalePortsTime: UntypedFormControl;
	public DisableStalePortsUnit: UntypedFormControl;
	public SeedScope: UntypedFormControl;
	public Keep: UntypedFormControl;
	public DeviceExpirationValue: UntypedFormControl;
	public DeviceExpirationUnit: UntypedFormControl;
	public Enabled: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
		this.BuildForm();
	}

	protected BuildForm(): void {
		let name = "";
		let method = DiscoveryMethod.PingSweep + "";
		let refreshMode = false;
		let reportSubtaskStatus = false;
		let keepStalePortReport = false;
		let seedScope = "";
		let keep = 1;
		let deviceExpirationValue = 1;
		let deviceExpirationUnit = TimeUnit.Days + "";
		let enabled = false;
		let disableStalePorts = false;
		let disableStalePortsTime = 1;
		let disableStalePortsUnit = TimeUnit.Days + "";

		if (this.Discovery && this.Settings) {
			name = this.Discovery.Name;
			method = this.Settings.Method + "";
			refreshMode = this.Discovery.IsDiscoveryRefresh;
			reportSubtaskStatus = this.Discovery.ReportSubtaskStatus;
			keepStalePortReport = this.Discovery.KeepStalePortReport;
			disableStalePorts = this.Discovery.DisableStalePorts;
			disableStalePortsTime = this.Discovery.DisableStalePortsTime;
			disableStalePortsUnit = this.Discovery.DisableStalePortsUnit + "";
			seedScope = this.Settings.SeedScope.ToString();
			keep = this.Discovery.Keep;
			deviceExpirationValue = this.Discovery.DeviceExpirationValue;
			deviceExpirationUnit = this.Discovery.DeviceExpirationUnit + "";
			enabled = this.Discovery.Enabled;
		}

		this.Name = new UntypedFormControl(name, Validators.required);
		this.Method = new UntypedFormControl(method, Validators.required);
		this.RefreshMode = new UntypedFormControl(refreshMode);
		this.ReportSubtaskStatus = new UntypedFormControl(reportSubtaskStatus);
		this.KeepStalePortReport = new UntypedFormControl(keepStalePortReport);
		this.DisableStalePorts = new UntypedFormControl(disableStalePorts);
		this.DisableStalePortsTime = new UntypedFormControl(disableStalePortsTime);
		this.DisableStalePortsUnit = new UntypedFormControl(disableStalePortsUnit);
		this.SeedScope = new UntypedFormControl(seedScope, Validators.required);
		this.Keep = new UntypedFormControl(keep, Validators.compose([Validators.required, this.minValue(1), this.maxValue(99)]));
		this.DeviceExpirationValue = new UntypedFormControl(deviceExpirationValue, Validators.compose([Validators.required, this.minValue(0), this.maxValue(999)]));
		this.DeviceExpirationUnit = new UntypedFormControl(deviceExpirationUnit, Validators.required);
		this.Enabled = new UntypedFormControl(enabled, Validators.required);

		this.SettingsForm = this.fb.group({
			Name: this.Name,
			Method: this.Method,
			RefreshMode: this.RefreshMode,
			ReportSubtaskStatus: this.ReportSubtaskStatus,
			KeepStalePortReport: this.KeepStalePortReport,
			DisableStalePorts: this.DisableStalePorts,
			DisableStalePortsTime: this.DisableStalePortsTime,
			DisableStalePortsUnit: this.DisableStalePortsUnit,
			SeedScope: this.SeedScope,
			Keep: this.Keep,
			DeviceExpirationValue: this.DeviceExpirationValue,
			DeviceExpirationUnit: this.DeviceExpirationUnit,
			Enabled: this.Enabled,
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
		this.BuildForm();
	}

	public applyTempChanges(): void {
		if (this.Discovery && this.Settings) {
			this.Discovery.Name = this.Name.value;
			this.Settings.Name = this.Name.value;
			this.Settings.Method = parseInt(this.Method.value);
			this.Discovery.IsDiscoveryRefresh = this.RefreshMode.value;
			this.Discovery.ReportSubtaskStatus = this.ReportSubtaskStatus.value;
			this.Discovery.KeepStalePortReport = this.KeepStalePortReport.value;
			this.Discovery.DisableStalePorts = this.DisableStalePorts.value;
			this.Discovery.DisableStalePortsTime = parseInt(this.DisableStalePortsTime.value);
			this.Discovery.DisableStalePortsUnit = parseInt(this.DisableStalePortsUnit.value);
			this.SaveScope(this.Settings.SeedScope, this.SeedScope.value);
			this.Discovery.Keep = parseInt(this.Keep.value);
			this.Discovery.DeviceExpirationValue = parseInt(this.DeviceExpirationValue.value);
			this.Discovery.DeviceExpirationUnit = parseInt(this.DeviceExpirationUnit.value);
			this.Discovery.Enabled = this.Enabled.value;

			this.BuildForm();
			this.onApplyTempChanges();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Discovery Settings"];
	}

}
